import React, {ReactElement} from 'react';
import {IElementLineV2} from '../../../incase-domain/elements/shapes/lineV2';
import {usePresScaleContext} from '../../../context/PresScaleContext';

interface LineElementV2Props {
    element: IElementLineV2;
    startPointPx?: {x: number; y: number};
    endPointPx?: {x: number; y: number};
}

function LineElementV2({element, startPointPx, endPointPx}: LineElementV2Props): ReactElement {
    const {color, size, startPoint, endPoint} = element;
    const {workspaceSize} = usePresScaleContext();
    const start = startPointPx ?? {x: startPoint.x * workspaceSize.width, y: startPoint.y * workspaceSize.height};
    const end = endPointPx ?? {x: endPoint.x * workspaceSize.width, y: endPoint.y * workspaceSize.height};
    const viewBox = workspaceSize.width && workspaceSize.height ? `0 0 ${workspaceSize.width} ${workspaceSize.height}` : undefined;

    return (
        <svg style={{height: '100%', width: '100%'}} viewBox={viewBox} preserveAspectRatio="none">
            <line
                className="invisibleClickable"
                x1={start.x}
                y1={start.y}
                x2={end.x}
                y2={end.y}
                stroke="transparent"
                strokeWidth="1em"
                pointerEvents="stroke"
            />
            <line x1={start.x} y1={start.y} x2={end.x} y2={end.y} stroke={color || 'black'} strokeWidth={`${size || 0.0625}em`} />
        </svg>
    );
}

export default LineElementV2;
